import React from "react";

interface ErrorMessageProps {
  error?: string;
  touched?: boolean;
}
const ErrorMessage: React.FC<ErrorMessageProps> = ({ error, touched }) => {
  return (
    <>
      <div
        style={{
          opacity: error && touched ? 1 : 0,
          display: error && touched ? "block" : "none",
          color: "#f44336",
          fontSize: "12px",
          fontWeight: 700,
          marginLeft: "8px",
          textAlign: "left",
          transition: "opacity 0.3s ease, visibility 0.3s ease",
        }}
      >
        {error}
      </div>
    </>
  );
};

export default ErrorMessage;
